export function exhaustiveMatchingGuard(_) {
    // void
    throw new Error('This should not be reachable');
}
